import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {PriceLevelMarkupSingleSelectColumnComponent} from "./price-level/controls/price-level-markup-single-select-column.component";
import {PriceLevelSingleSelectEditControlComponent} from "./price-level/controls/price-level-single-select-edit-control.component";
import {DiscountSingleSelectEditControlComponent} from "./discount/controls/discount-single-select-edit-control.component";
import {MarkupValueColumnComponent} from "./markup/controls/markup-value-column/markup-value-column.component";
import {PriceLevelReportSelectionControlComponent} from "./price-level/controls/price-level-report-selection-control.component";
import {MixAndMatchSingleSelectEditControlComponent} from "./mix-and-match/controls/mix-and-match-single-select-edit-control.component";
import {EntitlementSaleSingleSelectSearchControlComponent} from "./entitlement/controls/entitlement-sale-single-select-search-control.component";
import {EntitlementPromotionMultiSelectSearchControlComponent} from "./entitlement/controls/entitlement-promotion-multi-select-search-control.component";
import {EntitlementDistributionMultiSelectSearchControlComponent} from "./entitlement/controls/entitlement-distribution-multi-select-search-control.component";
import {SurchargeSingleSelectEditControlComponent} from "./surcharge/controls/surcharge-single-select-edit-control.component";
import {SurchargeReportSelectionControlComponent} from "./surcharge/controls/surcharge-report-selection-control.component";
import {SpecialSingleSelectEditControlComponent} from "./special/controls/special-single-select-edit-control.component";
import {EntitlementSingleSelectEditControlComponent} from "./entitlement/controls/entitlement-single-select-edit-control.component";
import {PricingScheduleEditComponent} from "./pricing-schedule/pricing-schedule-edit/pricing-schedule-edit.component";
import {SystemSharedModule} from "../system/system.shared.module";
import {PriceLevelSingleSelectColumnComponent} from "./price-level/controls/price-level-single-select-column.component";
import {DiscountReportSelectionControlComponent} from "./discount/controls/discount-report-selection-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        SystemSharedModule
    ],
    declarations: [
        PriceLevelMarkupSingleSelectColumnComponent,
        PriceLevelSingleSelectEditControlComponent,
        PriceLevelSingleSelectColumnComponent,
        SpecialSingleSelectEditControlComponent,
        DiscountSingleSelectEditControlComponent,
        EntitlementSingleSelectEditControlComponent,
        SurchargeSingleSelectEditControlComponent,
        SurchargeReportSelectionControlComponent,
        MarkupValueColumnComponent,
        PriceLevelReportSelectionControlComponent,
        MixAndMatchSingleSelectEditControlComponent,
        EntitlementSaleSingleSelectSearchControlComponent,
        EntitlementPromotionMultiSelectSearchControlComponent,
        EntitlementDistributionMultiSelectSearchControlComponent,
        PricingScheduleEditComponent,
        DiscountReportSelectionControlComponent
    ],
    exports: [
        PriceLevelMarkupSingleSelectColumnComponent,
        PriceLevelSingleSelectEditControlComponent,
        PriceLevelSingleSelectColumnComponent,
        SpecialSingleSelectEditControlComponent,
        DiscountSingleSelectEditControlComponent,
        EntitlementSingleSelectEditControlComponent,
        SurchargeSingleSelectEditControlComponent,
        SurchargeReportSelectionControlComponent,
        MarkupValueColumnComponent,
        PriceLevelReportSelectionControlComponent,
        MixAndMatchSingleSelectEditControlComponent,
        EntitlementSaleSingleSelectSearchControlComponent,
        EntitlementPromotionMultiSelectSearchControlComponent,
        EntitlementDistributionMultiSelectSearchControlComponent,
        PricingScheduleEditComponent,
        DiscountReportSelectionControlComponent
    ]
})
export class PricingSharedModule {
}
